export const createCustomerNews = ({token, item}) => {
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/create-customer-news`, {
    method: 'POST',
    body: JSON.stringify({
      item,
    }),
    headers: {
      token,
    },
  })
}

export const getCustomerNews = ({token}) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-customer-news`, {
    method: 'GET',
    headers: {
      token,
    },
  })

export const deleteCustomerNews = ({token, item}) => {
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/delete-customer-news`, {
    method: 'POST',
    body: JSON.stringify({
      item,
    }),
    headers: {
      token,
    },
  })
}

export const editCustomerNews = ({token, item, itemId}) => {
  return fetch(
    `${process.env.GATSBY_FUNCTION_PATH}/edit-customer-news?itemId=${itemId}`,
    {
      method: 'PUT',
      body: JSON.stringify({
        item,
      }),
      headers: {
        token,
      },
    },
  )
}
